'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Get the value of given key in object.
 *
 * @param {object} object
 * @param {string} key
 * @returns {*}
 */
var dotGet = function dotGet(object, key) {
  return key === null || key === void 0 ? void 0 : key.split('.').reduce(function (o, i) {
    return o && o[i];
  }, object);
};

exports.default = dotGet;
